import React, { useState } from 'react';
import styles from './ScrollButton.module.scss';
import { BsChevronUp } from 'react-icons/bs';
import clsx from 'clsx';

const ScrollButton = () => {
  const [visible, setVisible] = useState(false)
  
  const toggleVisible = () => {
    const scrolled = document.documentElement.scrollTop;
    if (scrolled > 300){
      setVisible(true)
    } 
    else if (scrolled <= 300){
      setVisible(false)
    }
  };
  
  const scrollToTop = () =>{
    window.scrollTo({
      top: 0, 
      behavior: 'smooth'
    });
  };
  
  window.addEventListener('scroll', toggleVisible);
  return (
    <button onClick={scrollToTop} className={clsx(styles.scrollButton, visible && styles.visible)} /* style={{display: visible ? 'inline' : 'none'}} */>
      <BsChevronUp />
    </button>
  )
}

export default ScrollButton